function wsGeo() {
    var status = '';

    var getLocation = function (successCallback, errorCallback, geoOptions) {
        status = 'requesting location';

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(successCallback, errorCallback, geoOptions);
        }
        else {
            status = 'Geolocation is not supported by this browser.';
        }
    }

    return {
        getLocation: getLocation,
        status: status
};
}

exports.WsGeo = wsGeo;
